import { css, cx } from "@emotion/css";
import { ListItem } from "@material-ui/core";
import React from "react";
interface ListItemButtonProps {
    className?: string;
    children: React.ReactNode;
    onClick: () => void;
}
/**
 * @deprecated Do not use this component. This exists specifically to support the process sidebar items in Portal.
 * The styling of the process sidebar is very tightly coupled to its markup which includes this component's implementation.
 */
export function LegacyListItemButton({ className, children, onClick }: ListItemButtonProps) {
    return (<ListItem button component="a" className={cx(styles.listItem, className)} disableGutters={true} onClick={onClick}>
            {children}
        </ListItem>);
}
const styles = {
    listItem: css({
        "&.MuiListItem-root": {
            padding: 0,
        },
    }),
};
